// This file is auto-generated by @hey-api/openapi-ts
import { formDataBodySerializer } from './client';
import { client } from './client.gen';
export class AssetDownloadService {
    /**
     * Download a public asset by ID
     */
    static downloadPublicAsset(options) {
        return (options.client ?? client).get({ url: '/d/public/{assetId}', ...options });
    }
    /**
     * Download asset via short URL
     */
    static downloadViaShortUrl(options) {
        return (options.client ?? client).get({ url: '/d/{shortId}', ...options });
    }
}
export class AssetsService {
    /**
     * Upload assets
     */
    static uploadAsset(options) {
        return (options.client ?? client).post({
            ...formDataBodySerializer,
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/assets',
            ...options,
            headers: {
                'Content-Type': null,
                ...options.headers
            }
        });
    }
    /**
     * Upload asset from URL
     */
    static uploadAssetFromUrl(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/assets/from-url',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Get upload URL for an asset
     */
    static getAssetUploadUrl(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/assets/presigned-post-url',
            ...options
        });
    }
    /**
     * Batch resolve signed download URLs for multiple assets
     *
     * Returns one entry per asset that resolved successfully. Assets that failed to resolve (missing or transient) are omitted — callers treat absence as a null URL. Used by list endpoints that need to surface N thumbnail URLs in a single round-trip.
     */
    static getAssetUrls(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/assets/urls',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * List the generated derivatives for an asset
     */
    static getAssetDerivatives(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/assets/{assetId}/derivatives',
            ...options
        });
    }
    /**
     * Generate the derivatives for an asset
     */
    static createAssetDerivatives(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/assets/{assetId}/derivatives',
            ...options
        });
    }
    /**
     * Delete an asset
     */
    static deleteAsset(options) {
        return (options.client ?? client).delete({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/assets/{assetId}',
            ...options
        });
    }
    /**
     * Get asset metadata by asset ID
     */
    static getAsset(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/assets/{assetId}',
            ...options
        });
    }
    /**
     * Get download URL for an asset
     */
    static getAssetDownloadUrl(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/assets/{assetId}/signed-url',
            ...options
        });
    }
    /**
     * Mark an asset as publicly accessible
     */
    static markAssetPublic(options) {
        return (options.client ?? client).patch({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/assets/{assetId}/public',
            ...options
        });
    }
    /**
     * Create a short-lived download URL for an asset
     */
    static createShortDownloadUrl(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/assets/{assetId}/short-url',
            ...options
        });
    }
    /**
     * Draw a still from a stored clip
     *
     * Extracts a frame a second into the video and stores it as a new asset, inheriting the source clip's organisation, workspace and project. Not idempotent: asking twice extracts twice, so a caller that records the result should only ask when it has none.
     */
    static extractPoster(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/assets/{assetId}/poster',
            ...options
        });
    }
}
export class KnowledgeBasesService {
    /**
     * Upload files for RAG processing
     *
     * Upload files to be processed and added to the knowledge bases.
     */
    static uploadFiles(options) {
        return (options.client ?? client).post({
            ...formDataBodySerializer,
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/knowledge-bases/{id}/upload',
            ...options,
            headers: {
                'Content-Type': null,
                ...options.headers
            }
        });
    }
    /**
     * Query documents from the knowledge bases
     */
    static queryDocuments(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/knowledge-bases/{id}/query',
            ...options
        });
    }
    /**
     * List knowledge bases by organization and optional workspace
     */
    static listKnowledgeBases(options) {
        return (options?.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/knowledge-bases',
            ...options
        });
    }
    /**
     * Create a new knowledge base
     */
    static createKnowledgeBase(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/knowledge-bases',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Delete knowledge base by ID
     */
    static deleteKnowledgeBase(options) {
        return (options.client ?? client).delete({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/knowledge-bases/{id}',
            ...options
        });
    }
    /**
     * Get knowledge base summary by ID with file count
     */
    static getKnowledgeBaseSummaryById(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/knowledge-bases/{id}',
            ...options
        });
    }
    /**
     * Update knowledge base details
     */
    static updateKnowledgeBase(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/knowledge-bases/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Get the workspaces a knowledge base is shared with
     */
    static getKnowledgeBaseWorkspaces(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/knowledge-bases/{id}/workspaces',
            ...options
        });
    }
    /**
     * Share or unshare a knowledge base across workspaces of its own organization
     */
    static updateKnowledgeBaseWorkspaces(options) {
        return (options.client ?? client).patch({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/knowledge-bases/{id}/workspaces',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Get files associated with a knowledge base
     */
    static getFilesByKnowledgeBaseId(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/knowledge-bases/{id}/files',
            ...options
        });
    }
    /**
     * List files across multiple knowledge bases, filtered by file extension
     */
    static getFilesByExtension(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/knowledge-bases/files/by-extension',
            ...options
        });
    }
    /**
     * Get the full verbatim text content of a knowledge base file
     */
    static getFileContent(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/knowledge-bases/files/{fileId}/content',
            ...options
        });
    }
    /**
     * Deletes file from knowledge base
     */
    static deleteFileFromKnowledgeBase(options) {
        return (options.client ?? client).delete({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/knowledge-bases/{id}/files/{fileId}',
            ...options
        });
    }
    /**
     * List documents of a specific file
     */
    static listDocumentsByFileId(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/knowledge-bases/{id}/files/{fileId}/documents',
            ...options
        });
    }
}
export class InternalKnowledgeBasesService {
    /**
     * Get foundational knowledge base ID by name
     */
    static getFoundationalKnowledgeBaseIdByName(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/internal/knowledge-bases/id-by-name',
            ...options
        });
    }
    /**
     * Create an owned knowledge base
     *
     * Owned by a single entity on the calling service (e.g. user-defined agent file store). Hidden from all general listings and from public KB endpoints. Auth must be enforced upstream by the caller.
     */
    static createOwnedKnowledgeBase(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/internal/knowledge-bases/owned',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * List files in an owned knowledge base
     */
    static listOwnedKnowledgeBaseFiles(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/internal/knowledge-bases/{id}/files',
            ...options
        });
    }
    /**
     * Upload files to an owned knowledge base
     */
    static uploadFilesToOwnedKnowledgeBase(options) {
        return (options.client ?? client).post({
            ...formDataBodySerializer,
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/internal/knowledge-bases/{id}/files',
            ...options,
            headers: {
                'Content-Type': null,
                ...options.headers
            }
        });
    }
    /**
     * Delete a file from an owned knowledge base
     */
    static deleteOwnedKnowledgeBaseFile(options) {
        return (options.client ?? client).delete({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/internal/knowledge-bases/{id}/files/{fileId}',
            ...options
        });
    }
    /**
     * Delete an owned knowledge base entirely
     */
    static deleteOwnedKnowledgeBase(options) {
        return (options.client ?? client).delete({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/internal/knowledge-bases/{id}',
            ...options
        });
    }
}
export class DocumentConversionService {
    /**
     * Convert an Office document to PDF
     */
    static convertToPdf(options) {
        return (options.client ?? client).post({
            ...formDataBodySerializer,
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/convert/to-pdf',
            ...options,
            headers: {
                'Content-Type': null,
                ...options.headers
            }
        });
    }
    /**
     * Get conversion job status
     */
    static getConversionStatus(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/convert/status/{jobId}',
            ...options
        });
    }
}
export class BriefTemplatesService {
    /**
     * List the brief templates available in the current workspace
     *
     * System defaults, the organization's templates and the workspace's own, each with its level and effective enabled flag. Levels the caller has no view key for are left out. Brief creation lists with status=published&enabled=true.
     */
    static list(options) {
        return (options?.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/brief-templates',
            ...options
        });
    }
    /**
     * Create a new brief template
     *
     * Workspace level by default. Organization and system levels need their manage key and the brief_template_levels flag.
     */
    static create(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/brief-templates',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Soft delete a brief template
     */
    static delete(options) {
        return (options.client ?? client).delete({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/brief-templates/{id}',
            ...options
        });
    }
    /**
     * Get a brief template by ID with sections and fields
     */
    static getById(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/brief-templates/{id}',
            ...options
        });
    }
    /**
     * Update a brief template
     */
    static update(options) {
        return (options.client ?? client).patch({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/brief-templates/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Publish a brief template
     */
    static publish(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/brief-templates/{id}/publish',
            ...options
        });
    }
    /**
     * Promote a workspace template to its organization
     *
     * The template becomes available in every workspace of the organization, including workspaces created later. Needs the organization template manage key and the brief_template_levels flag. Demotion is not supported.
     */
    static promote(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/brief-templates/{id}/actions/promote',
            ...options
        });
    }
    /**
     * Turn a brief template off
     *
     * An off template is no longer offered in brief creation; it stays listed, readable and editable, and briefs already created from it are unaffected. Needs the manage key of the template's level. An organization template manager turns a system default off for their organization only. Gated by the brief_template_levels flag.
     */
    static turnOff(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/brief-templates/{id}/actions/turn-off',
            ...options
        });
    }
    /**
     * Turn a brief template back on
     *
     * Offers the template in brief creation again, with the same rights as turning it off.
     */
    static turnOn(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/brief-templates/{id}/actions/turn-on',
            ...options
        });
    }
    /**
     * Resolve a brief template id to its owning workspace and organization
     *
     * Accepts the brief template id regardless of the selected workspace. Reveals organization identity only to members of that organization.
     */
    static resolveWorkspace(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/brief-templates/{id}/resolve-workspace',
            ...options
        });
    }
}
export class InternalService {
    /**
     * List recent asset ownership migration runs
     */
    static list(options) {
        return (options?.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/internal/asset-ownership-migration/runs',
            ...options
        });
    }
    /**
     * Start an asset ownership migration run
     *
     * Defaults to a dry run, which records exactly what it would stamp and changes nothing.
     */
    static start(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/internal/asset-ownership-migration/runs',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Undo a migration run
     *
     * Unsets the ownership that run stamped, leaving each asset unowned again. An asset is reverted only while it still holds exactly the organization and workspace the run wrote, One holding anything else is left as it is.
     */
    static rollback(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/internal/asset-ownership-migration/runs/{runId}/rollback',
            ...options
        });
    }
    /**
     * Stop an asset ownership migration run
     *
     * The worker stops at its next batch boundary rather than immediately. Assets already stamped stay stamped and can be rolled back.
     */
    static cancel(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/internal/asset-ownership-migration/runs/{runId}/cancel',
            ...options
        });
    }
    /**
     * Progress and results of one asset ownership migration run
     */
    static get(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/internal/asset-ownership-migration/runs/{runId}',
            ...options
        });
    }
    /**
     * Places a reverse-dedup run rewrote, or still has to
     *
     * A rollback reports on the rewrites of the run it undoes, since a rewrite is always recorded against the run that planned it.
     */
    static listRewrites(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/internal/asset-ownership-migration/runs/{runId}/rewrites',
            ...options
        });
    }
}
export class TaxonomiesService {
    /**
     * List taxonomies visible in the current workspace
     */
    static list(options) {
        return (options?.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomies',
            ...options
        });
    }
    /**
     * Create a new taxonomy with its initial version
     */
    static create(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomies',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Soft delete a taxonomy
     */
    static delete(options) {
        return (options.client ?? client).delete({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomies/{id}',
            ...options
        });
    }
    /**
     * Get a taxonomy by ID with its version history
     */
    static getById(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomies/{id}',
            ...options
        });
    }
    /**
     * Get the audit trail for a taxonomy
     */
    static changeLog(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomies/{id}/change-log',
            ...options
        });
    }
    /**
     * Generate a unique tracking code for a computed field
     *
     * MANAGE, though naming an asset is conceptually a read-side use of a schema. Minting allocates a sequence counter and an assignment row, and no path deletes one. Idempotence is keyed on `assetKey` when the caller supplies one, and otherwise on the resolved field values — so an UNANCHORED caller varying any value allocates again and nothing rate-limits that. Callers are the builder’s sample-code previews (unanchored, and the reason this stays MANAGE) and the record grid, which anchors on its record id.
     */
    static generateTrackingCode(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomies/{id}/tracking-codes',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * LLM-generated pack of code abbreviations to fit a channel character budget
     *
     * MANAGE, not VIEW: this is an authoring aid reached from the builder, and the only thing a caller can do with the answer is edit the schema. It also spends real money on an LLM call per request, so it must not be reachable by a read-only role.
     */
    static suggestAbbreviations(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomies/{id}/abbreviation-suggestions',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Delete several schemas, sharing one justification
     */
    static bulkDelete(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomies/bulk-delete',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Copy a schema, including its fields and rules
     *
     * Field IDs are re-minted and rules remapped onto the copies.
     */
    static duplicate(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomies/{id}/duplicate',
            ...options
        });
    }
    /**
     * Branch a new version off a taxonomy
     */
    static addVersion(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomies/{id}/versions',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Update a draft version in place (builder autosave)
     */
    static updateDraft(options) {
        return (options.client ?? client).patch({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomies/{id}/versions/{versionId}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Transition a version lifecycle status
     */
    static setVersionStatus(options) {
        return (options.client ?? client).patch({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomies/{id}/versions/{versionId}/status',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class TaxonomyListsService {
    /**
     * List shared vocabularies visible in this workspace
     */
    static list(options) {
        return (options?.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomy-lists',
            ...options
        });
    }
    /**
     * Create a shared vocabulary
     */
    static create(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomy-lists',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Seed the org library from the shipped Standard Lists catalog
     *
     * Idempotent: entries the library already holds are skipped. Returns only the lists actually created.
     */
    static seedStandard(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomy-lists/seed-standard',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Delete several lists, skipping any still bound by a schema
     *
     * Partial by design: returns what was deleted and what was kept, so one in-use list does not fail the whole batch.
     */
    static bulkDelete(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomy-lists/bulk-delete',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * The Standard Lists on offer, flagged with what this org already has
     *
     * Metadata + row COUNTS only — the rows themselves never leave the server, which is why the catalog lives here.
     */
    static standardCatalog(options) {
        return (options?.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomy-lists/standard-catalog',
            ...options
        });
    }
    /**
     * Soft-delete a list (refused while schemas still reference it)
     */
    static delete(options) {
        return (options.client ?? client).delete({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomy-lists/{id}',
            ...options
        });
    }
    /**
     * Get a shared vocabulary with its version history
     */
    static getById(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomy-lists/{id}',
            ...options
        });
    }
    /**
     * How many live schemas bind a field to this list
     */
    static usage(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomy-lists/{id}/usage',
            ...options
        });
    }
    /**
     * A list's append-only audit trail, newest first
     */
    static changeLog(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomy-lists/{id}/change-log',
            ...options
        });
    }
    /**
     * Which schemas bind to this list, and which will change on publish
     */
    static impact(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomy-lists/{id}/impact',
            ...options
        });
    }
    /**
     * Which schemas a delete of this list would be refused for
     *
     * Unlike `/impact`, which reads head versions only, this counts published snapshots too, exactly as the delete guard does.
     */
    static blockingSchemas(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomy-lists/{id}/blocking-schemas',
            ...options
        });
    }
    /**
     * Copy a list, including its options
     *
     * The copy is always a CUSTOM list with fresh column/row IDs, even when duplicating a standard one.
     */
    static duplicate(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomy-lists/{id}/duplicate',
            ...options
        });
    }
    /**
     * Autosave a draft version's columns/rows
     */
    static updateDraft(options) {
        return (options.client ?? client).patch({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomy-lists/{id}/versions/{versionId}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Branch a new draft version, carrying content forward
     */
    static addVersion(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomy-lists/{id}/versions',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Publish or archive a list version
     */
    static setVersionStatus(options) {
        return (options.client ?? client).patch({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomy-lists/{id}/versions/{versionId}/status',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class TaxonomyCategoriesService {
    /**
     * List field categories, in rail order
     */
    static list(options) {
        return (options?.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomy-categories',
            ...options
        });
    }
    /**
     * Create a field category
     */
    static create(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomy-categories',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Seed the registry from the shipped standard-category catalog
     *
     * Idempotent: categories the registry already holds are skipped, so this also restores ones that were deleted. Returns only the categories actually created.
     */
    static seedStandard(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomy-categories/seed-standard',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Remove several categories from the registry
     *
     * Same re-filing as a single delete: every field definition in the removed categories moves to "Uncategorized". Ids that no longer exist are skipped rather than failing the batch.
     */
    static bulkDelete(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomy-categories/bulk-delete',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Remove a category from the registry
     *
     * Field definitions in the category are re-filed under "Uncategorized" in the same transaction — fields reference a category by name, so leaving them behind would group them under a label with no row. The response reports how many moved.
     */
    static delete(options) {
        return (options.client ?? client).delete({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomy-categories/{id}',
            ...options
        });
    }
    /**
     * Rename a category or change its icon/order
     *
     * Renaming also re-points every field definition using the old name, in one transaction — fields reference a category by name, so a partial rename would split one rail entry in two.
     */
    static update(options) {
        return (options.client ?? client).patch({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomy-categories/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class TaxonomyFieldTemplatesService {
    /**
     * List reusable field definitions visible in this workspace
     */
    static list(options) {
        return (options?.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomy-field-templates',
            ...options
        });
    }
    /**
     * Create a reusable field definition
     */
    static create(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomy-field-templates',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Create many field definitions (seeds the standard-fields catalog)
     */
    static createMany(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomy-field-templates/bulk',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Delete several reusable field definitions
     */
    static bulkDelete(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomy-field-templates/bulk-delete',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Restore field definitions the caller removed from the library
     *
     * Partial by design: a standard field whose key a live field has taken since is reported in `blocked`, and ids that are not the caller's own removals are skipped.
     */
    static restore(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomy-field-templates/actions/restore',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * A template's audit trail, newest first
     *
     * Templates are deliberately unversioned (copy-on-add), so this trail carries full before/after snapshots rather than version references. It outlives the template.
     */
    static changeLog(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomy-field-templates/{id}/change-log',
            ...options
        });
    }
    /**
     * Remove a field definition from the library
     */
    static delete(options) {
        return (options.client ?? client).delete({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomy-field-templates/{id}',
            ...options
        });
    }
    /**
     * Update a reusable field definition
     */
    static update(options) {
        return (options.client ?? client).patch({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomy-field-templates/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class TaxonomyDatasetsService {
    /**
     * List taxonomies visible in the current workspace
     */
    static list(options) {
        return (options?.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomy-datasets',
            ...options
        });
    }
    /**
     * Create a taxonomy against a published schema version
     *
     * Refuses a draft or archived version: a draft is editable in place, so a name generated from it could change meaning after it has been used.
     */
    static create(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomy-datasets',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Soft-delete a taxonomy
     */
    static delete(options) {
        return (options.client ?? client).delete({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomy-datasets/{id}',
            ...options
        });
    }
    /**
     * Get one taxonomy
     */
    static getById(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomy-datasets/{id}',
            ...options
        });
    }
    /**
     * Rename a taxonomy or move it to another campaign
     *
     * No `reason` and no change-log entry — unlike a schema lifecycle change, neither edit alters anything a generated name depends on. Both fields are optional; a null `campaignId` moves the taxonomy to Ungrouped.
     */
    static update(options) {
        return (options.client ?? client).patch({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomy-datasets/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Copy a taxonomy and its records
     *
     * The copy arrives with its records unassembled — a generated name is unique per schema, so cloning the names would collide with the originals.
     */
    static duplicate(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomy-datasets/{id}/duplicate',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * One page of records, in grid order
     *
     * Keyset paginated. Rows are inserted and deleted while someone is paging, and an offset silently skips and repeats under exactly that.
     */
    static listRecords(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomy-datasets/{id}/records',
            ...options
        });
    }
    /**
     * Apply a batch of record edits
     *
     * Each write is conditional on the revision the client held. The response separates what landed from what lost a race, so a conflict is identified without a second round trip.
     */
    static applyRecordWrites(options) {
        return (options.client ?? client).patch({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomy-datasets/{id}/records',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Append empty records
     *
     * Pre-filled with the schema's declared field defaults.
     */
    static appendRecords(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomy-datasets/{id}/records',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Empty records without removing them
     *
     * Separate from the batch write because that one MERGES a patch, so an empty patch is a no-op. Clearing has to replace.
     */
    static clearRecords(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomy-datasets/{id}/records/clear',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Download the records as a workbook
     *
     * Decomposed: one column per attribute, then each output assembled string, then a stable record id. Exporting only the name would be lossy, because a name cannot be taken apart again once a value in it contains the separator.
     */
    static exportRecords(options) {
        return (options.client ?? client).get({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomy-datasets/{id}/records/export',
            ...options
        });
    }
    /**
     * Mint tracking codes for the selected records
     *
     * Spends from the schema’s lifetime code budget, which nothing releases. Returns each code rather than storing it: the caller writes it through the normal save, so the assembled name is produced in one place. Anchored on the record id, so asking twice returns the same code instead of spending a second one.
     */
    static generateRecordCodes(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomy-datasets/{id}/records/tracking-codes',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Delete several records
     */
    static deleteRecords(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomy-datasets/{id}/records/bulk-delete',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class TaxonomyCampaignsService {
    /**
     * List the workspace campaigns, alphabetically
     *
     * A bare array, matching the sibling taxonomy-datasets index. Campaigns with no taxonomies are included — the list page still renders them.
     */
    static list(options) {
        return (options?.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomy-campaigns',
            ...options
        });
    }
    /**
     * Create a campaign
     *
     * Names are deliberately not unique, so this never conflicts.
     */
    static create(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomy-campaigns',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Remove a campaign and release its taxonomies
     *
     * The taxonomies are KEPT and move to Ungrouped. Deleting a campaign regroups; it never cascades to the taxonomies inside it.
     */
    static remove(options) {
        return (options.client ?? client).delete({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomy-campaigns/{id}',
            ...options
        });
    }
    /**
     * Rename a campaign or change its description
     *
     * Omitted fields are left alone; a null description clears it.
     */
    static update(options) {
        return (options.client ?? client).patch({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomy-campaigns/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class AdFormatsService {
    /**
     * The organization's own ad formats (any authenticated workspace member)
     *
     * Answers 200 with an empty row set when the organization has never seeded an Ad Formats list, so a caller can always use the result without treating absence as a failure. Content Studio no longer calls this; it reads the format library.
     */
    static list(options) {
        return (options?.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/ad-formats',
            ...options
        });
    }
}
export class FormatSpecsService {
    /**
     * The latest curated ad format library
     *
     * Answers 304 when `If-None-Match` names the current version, so a client polling on a short stale time costs one cheap query. The library is a single versioned document rather than a paged list, so clients get one coherent snapshot.
     */
    static latest(options) {
        return (options?.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/format-specs',
            ...options
        });
    }
    /**
     * The library as it was at one version
     */
    static version(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/format-specs/versions/{number}',
            ...options
        });
    }
    /**
     * One format of the latest library
     */
    static format(options) {
        return (options.client ?? client).get({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/format-specs/{formatId}',
            ...options
        });
    }
}
export class FormatSpecsAdminService {
    /**
     * The whole editable library, with revisions
     *
     * What the admin panel loads: every group, format, profile, value and limit as stored. The library is a single versioned document rather than a paged list, so the panel edits one coherent snapshot.
     */
    static library(options) {
        return (options?.client ?? client).get({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/admin/format-library',
            ...options
        });
    }
    static createGroup(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/admin/platform-groups',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    static updateGroup(options) {
        return (options.client ?? client).patch({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/admin/platform-groups/{key}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    static createFormat(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/admin/formats',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    static updateFormat(options) {
        return (options.client ?? client).patch({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/admin/formats/{key}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    static createProfile(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/admin/spec-profiles',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    static updateProfile(options) {
        return (options.client ?? client).patch({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/admin/spec-profiles/{key}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Every version, newest first, without snapshots
     */
    static listVersions(options) {
        return (options?.client ?? client).get({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/admin/dataset-versions',
            ...options
        });
    }
    /**
     * One version as consumers would have read it
     */
    static version(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/admin/dataset-versions/{number}',
            ...options
        });
    }
    /**
     * Put the library, or one format, back as it was at a version
     *
     * Creates a new version; history is never rewritten. Records created since that version are kept.
     */
    static restore(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/admin/dataset-versions/{number}/actions/restore',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Every recorded change, newest version first
     */
    static auditEvents(options) {
        return (options?.client ?? client).get({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/admin/audit-events',
            ...options
        });
    }
    /**
     * Download the library as CSV
     *
     * One file per entity, or `all` for every file in a zip. Each row records the version it came from.
     */
    static export(options) {
        return (options.client ?? client).get({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/admin/exports/{entity}',
            ...options
        });
    }
    /**
     * Upload CSV files and get a preview
     *
     * Nothing is applied until the import is confirmed. Files are recognised by their header row, so a renamed file still imports.
     */
    static createImport(options) {
        return (options.client ?? client).post({
            ...formDataBodySerializer,
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/admin/imports',
            ...options,
            headers: {
                'Content-Type': null,
                ...options.headers
            }
        });
    }
    /**
     * The preview, recomputed against the library as it is now
     */
    static getImport(options) {
        return (options.client ?? client).get({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/admin/imports/{id}',
            ...options
        });
    }
    /**
     * Resolve conflicts and confirm breaking changes before confirming
     */
    static updateImport(options) {
        return (options.client ?? client).patch({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/admin/imports/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Every row the import could not use, with the reason, as CSV
     */
    static ignoredRows(options) {
        return (options.client ?? client).get({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/admin/imports/{id}/ignored-rows',
            ...options
        });
    }
    /**
     * Apply the import as one new version
     */
    static confirm(options) {
        return (options.client ?? client).post({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/admin/imports/{id}/actions/confirm',
            ...options
        });
    }
}
